import React from "react";
import TemporaryDrawer from "./Drawer";
import HomeIcon from "@material-ui/icons/Home";
import PersonIcon from "@material-ui/icons/Person";
import WorkIcon from "@material-ui/icons/Work";

export default class Portfolio extends React.Component {
  render() {
    return (
      <>
        <TemporaryDrawer
          name_path={[
            { name: "Home", path: "/", icon: <HomeIcon /> },
            { name: "Profile", path: "/profile", icon: <PersonIcon /> },
            { name: "Portfolio", path: "/portfolio", icon: <WorkIcon /> },
          ]}
        />
        <div id="profile" className="col-sm-12">
          <h1>About me!</h1>
        </div>
        <div id="about" className="col-sm-12">
          <p>
            I am an experienced Datacenter, Enterprise, and Service-Provider
            Core Network Engineer with rich years of experience in Network
            Infrastructure Design, Development, Deployment and Operational
            Maintenance. I'm also Enthusiastic about automated workflows which
            affords me ample time to be productive at work and focus on learning
            new ways of doing things and keep up with the fast-paced
            technological evolution. VBA and Python are my Go-to languages for
            achivieving work-flow automation.
          </p>
          <p>
            I am a part-time fullStack web developer with specialty in
            JavaScript, its frameworks and libraries. I build intuitive, fast,
            responsive, highly scalable and robust website to meet personal,
            business and company needs as well as web applications tailored to
            meet specific business needs.
          </p>
          <p>Do well to check out my skills in the profile section.</p>
        </div>
      </>
    );
  }
}
